export default "__VITE_PUBLIC_ASSET__ad1984f0__"